import React from "react"
import { FormattedMessage, injectIntl } from "react-intl"
import { OnlinePaymentReceipt } from "../state/helpers/OnlinePaymentReceipt"
import PaymentDetails from "./paymentdetails.component"

type OwnProps = {
    payments: OnlinePaymentReceipt[],
    variables,
}

const OnlinePaymentReceiptSection = (props: OwnProps) => {
    const { payments, variables } = props
    if (payments.length === 0) {
        return ""
    }

    const isTerminalPayment = (payment : OnlinePaymentReceipt) => payment.terminalId !== ""

    const terminalPayments = payments.filter(isTerminalPayment)
    const onlinePayments = payments.filter((payment) => !isTerminalPayment(payment))

    return (
        <>
            {onlinePayments.length > 0 && (<div className={"col-12 mb-0 mt-2 pt-3 border-top text-dark"}>
                <div className={"row"}>
                    <div className={"col-12 text-center h4"}>
                        <FormattedMessage
                            id="payment.received_payment_title_receipt"
                            defaultMessage="Online Payment Receipt"
                        />
                    </div>
                </div>
                {
                    onlinePayments.map((pay, i) => {
                        return <PaymentDetails key={i} pay={pay} variables={variables} />
                    })
                }
            </div>)}
            {terminalPayments.length > 0 && (<div className={"col-12 mb-0 mt-2 pt-3 border-top text-dark"}>
                <div className={"row"}>
                    <div className={"col-12 text-center h4"}>
                        <FormattedMessage
                            id="payment.received_payment_title_receipt_terminal"
                            defaultMessage="Terminal Payment Receipt"
                        />
                    </div>
                </div>
                {
                    terminalPayments.map((pay, i) => {
                        return <PaymentDetails key={i} pay={pay} variables={variables} />
                    })
                }
            </div>)}
        </>
    )
}

export default injectIntl(OnlinePaymentReceiptSection)


// WEBPACK FOOTER //
// ./src/payment/onlinepaymentreceiptsection.component.tsx